import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify' // <-- 'vuetify' di-impor di sini
import { createPinia, PiniaVuePlugin } from 'pinia'

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import './axios';

Vue.use(PiniaVuePlugin);
Vue.config.productionTip = false
Vue.use(VueToast)

new Vue({
  router,
  vuetify,
  pinia: createPinia(),
  render: h => h(App)
}).$mount('#app')